import { useRecordContext } from 'react-admin';
import CircularProgress from '@mui/material/CircularProgress';

import { useAuditLog } from '@pumpkincare/users';

import Tile from '../../shared/components/Tile';

function AuditLogDetails() {
  const record = useRecordContext();
  const { data, isLoading } = useAuditLog(record.id);

  return isLoading ? (
    <CircularProgress color='inherit' size={20} />
  ) : (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px' }}>
      {data.details.map(({ title, value }, index) => (
        <Tile key={index} title={title} content={value} />
      ))}
    </div>
  );
}

export default AuditLogDetails;
